import {
    GetClaimFeeTxnArgs,
    GetUpdateLiquidityTxnArgs,
    GetUpdatePositionTxnArgs,
    getWhirlpoolClaimFeeTransaction,
    getWhirlpoolUpdateLiquidityTransaction,
    getWhirlpoolUpdatePositionTransaction
} from "@bridgesplit/abf-sdk";

import { AbfTransactionDetails, AbfGeneratorResult } from "../types";
import { useAbfGenerateTransaction, wrapAsAbfGeneratorResult } from "./common";
import { useCreateSimulationPromise } from "./simulation";
import { useAbfFetches } from "../reducers";

export function useWhirlpoolClaimFeeTransaction(): AbfTransactionDetails<GetClaimFeeTxnArgs> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: GetClaimFeeTxnArgs): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({ generateFunction: getWhirlpoolClaimFeeTransaction, identifier: "Claim fees", params: args }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
        }
    };
    return { getTransactionsWithParams, sendOptions, description: "Claim fees" };
}

export function useWhirlpoolUpdatePositionTransaction(): AbfTransactionDetails<GetUpdatePositionTxnArgs> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: GetUpdatePositionTxnArgs): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({
                generateFunction: getWhirlpoolUpdatePositionTransaction,
                identifier: "Update position",
                params: args
            }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
        }
    };
    return { getTransactionsWithParams, sendOptions, description: "Update position" };
}

export function useWhirlpoolIncreaseLiquidityTransaction(): AbfTransactionDetails<GetUpdateLiquidityTxnArgs> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: GetUpdateLiquidityTxnArgs): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({
                generateFunction: getWhirlpoolUpdateLiquidityTransaction,
                identifier: "Increase liquidity",
                params: args
            }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
        }
    };
    return { getTransactionsWithParams, sendOptions, description: "Increase liquidity" };
}

export function useWhirlpoolDecreaseLiquidityTransaction(): AbfTransactionDetails<GetUpdateLiquidityTxnArgs> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: GetUpdateLiquidityTxnArgs): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({
                generateFunction: getWhirlpoolUpdateLiquidityTransaction,
                identifier: "Withdraw liquidity",
                params: args
            }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
        }
    };
    return { getTransactionsWithParams, sendOptions, description: "Withdraw liquidity" };
}
